import { ExtendedDtoBasket } from '@epicuro-next/data/baskets-dto';
import { Basket, ReviewStatus } from 'graphql-api/baskets-api-interfaces';

export const isWaitingForReview = (basket: ExtendedDtoBasket | Basket) =>
  Boolean(basket.reviewNeeded && basket.reviewStatus === ReviewStatus.Pending);
